/** @flow */

import { compose } from "redux";
import type { State } from "@store/reducers";
import type { TrendsType } from "@modules/reporting/reducer/trends/types";
import type {
  AbsenceRateReport,
  AbsenceRateReportDetails,
  AbsenceRateReportViewState,
} from "@modules/reporting/reducer/trends/absence-rate/types";

import { enrichReportData } from "./report-enricher";

export const getAbsenceRate = (state: State): $PropertyType<TrendsType, "absenceRate"> =>
  state.reporting.trends.absenceRate;

export const getDefaultReports = (state: State): Array<AbsenceRateReport> =>
  getAbsenceRate(state).defaultReports || [];

export const getMyReports = (state: State): Array<AbsenceRateReport> =>
  getAbsenceRate(state).myReports || [];

export const getReportData = (state: State): AbsenceRateReportDetails =>
  getAbsenceRate(state).report;

export const getEnrichedReportData = (state: State): AbsenceRateReportDetails => {
  return enrichReportData(getReportData(state));
};

export const getReportsSchema = (state: State): ?Object => getAbsenceRate(state).schema;

export const getReportToSave = (state: State): ?AbsenceRateReport =>
  getAbsenceRate(state).reportToSave;

export const getViewState = (state: State): AbsenceRateReportViewState =>
  state.reporting.trends.absenceRate.viewState;

export type IsLoading = (state: State) => boolean;
export const isLoading: IsLoading = compose(state => state.requestsInProgress > 0, getAbsenceRate);
export const reportGenerateInProgress = (state: State) => {
  return state.reporting.trends.absenceRate.reportGenerateInProgress > 0;
};
export const getHeadcountModalVisible = (state: State) => {
  return state.reporting.modals.headcountModal.visible;
};
